/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accept_AllInputs */

const en_accept_all = /** @type {(inputs: Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept all`)
};

const es_accept_all = /** @type {(inputs: Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar todo`)
};

const fr_accept_all = /** @type {(inputs: Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout accepter`)
};

/**
* | output |
* | --- |
* | "Accept all" |
*
* @param {Accept_AllInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const accept_all = /** @type {((inputs?: Accept_AllInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accept_AllInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accept_all(inputs)
	if (locale === "es") return es_accept_all(inputs)
	return fr_accept_all(inputs)
});